import { fmtDate } from '../utils/features';

import '../styles/sg.css';

// Línea temporal de identidades de la vaca (admin-sg.md · B2 `identities`): número
// cowre vigente (`current`) + números observados en las fichas SG (`sg`, marca la
// representante con is_current) + renumeraciones registradas (`history`, `at` = fecha
// de REGISTRO del cambio, no de vigencia real — limitación documentada de la tabla).
// El backend ya deduplica por número normalizado con precedencia current > sg > history.

const SOURCE_LABEL = { current: 'Actual', sg: 'SG', history: 'Histórico' };

export default function SgIdentities({ identities }) {
    const list = Array.isArray(identities) ? identities : [];
    if (!list.length) return null;
    return (
        <div className="sg-ids" aria-label="Línea temporal de identidades">
            {list.map((it, i) => (
                <span
                    key={`${it.source}-${it.number ?? i}`}
                    className={`sg-ids__chip sg-ids__chip--${it.source}${it.is_current ? ' sg-ids__chip--marked' : ''}`}
                    title={[
                        SOURCE_LABEL[it.source] || it.source,
                        it.hoja_id ? `hoja ${it.hoja_id}` : null,
                        it.name_norm || null,
                        it.event_count != null ? `${it.event_count} eventos` : null,
                        it.at ? `registrado ${fmtDate(it.at)}` : null,
                    ].filter(Boolean).join(' · ')}
                >
                    <span className="sg-ids__num">{it.number ?? '—'}</span>
                    <span className="sg-ids__src">{SOURCE_LABEL[it.source] || it.source}</span>
                </span>
            ))}
        </div>
    );
}
